import {Component, forwardRef, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-heures-minutes-edit',
  templateUrl: './heures-minutes-edit.component.html',
  styleUrls: ['./heures-minutes-edit.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HeuresMinutesEditComponent),
      multi: true,
    },
  ],
})
export class HeuresMinutesEditComponent implements OnInit, ControlValueAccessor, OnDestroy {
  private subscription: Subscription;

  constructor(private formBuilder: UntypedFormBuilder) {
    const isNumberValidator = ctrl => {
      if (ctrl.value == null || ctrl.value == '') {
        return null;
      }
      if (isNaN(Number(ctrl.value)) || ctrl.value === null || ctrl.value === undefined) {
        return {pasUnNombre: ctrl.value};
      } else {
        return null;
      }
    };
    this.heuresControl = new UntypedFormControl(null, isNumberValidator);
    this.minutesControl = new UntypedFormControl(null, [isNumberValidator]);
    this.form = formBuilder.group({
      heures: this.heuresControl,
      minutes: this.minutesControl,
    });

    this.subscription = this.form.valueChanges.subscribe(f => {
      if (this.minutesControl.value > 59) {
        this.minutesControl.setValue(59);
      } else if (this.minutesControl.value < 0) {
        this.minutesControl.setValue(0);
      } else if (this.heuresControl.value < 0) {
        this.heuresControl.setValue(0);
      } else {
        this.yieldValue();
      }
    });
  }

  private get inputsAreEmpty() {
    return this.heuresControl.value == '' && this.minutesControl.value == '';
  }

  private get outputValue(): string {
    return HeuresMinutesEditComponent.stringFromHeuresMinutes(
      +this.heuresControl.value,
      +this.minutesControl.value,
      this.inputsAreEmpty,
    );
  }

  form: UntypedFormGroup;

  minutesControl: UntypedFormControl;
  heuresControl: UntypedFormControl;

  onChange: (any) => any = null;

  static stringFromHeuresMinutes(heures: number, minutes: number, areEmpty: boolean = false): string {
    if (!areEmpty) {
      const minutesPretty = minutes == null ? '' : minutes;
      return `${heures}:${minutesPretty}`;
    } else {
      return null;
    }
  }

  static heuresMinutesFromString(value: string): {heures: number; minutes: number} {
    if (value && value != '') {
      const [heuresString, minutesString] = value.split(/[:hH]/);
      if (!isNaN(Number(heuresString)) && !isNaN(Number(minutesString))) {
        return {
          heures: +heuresString,
          minutes: +minutesString,
        };
      }
    }
    return null;
  }

  ngOnInit() {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  private setFormValue(value: string) {
    const heuresEtMinutes = HeuresMinutesEditComponent.heuresMinutesFromString(value);
    if (heuresEtMinutes) {
      this.form.reset(heuresEtMinutes);
    }
  }

  private notifyChange(value: string) {
    if (this.onChange != null) {
      this.onChange(value);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  writeValue(obj: string): void {
    if (obj != this.outputValue) {
      this.setFormValue(obj);
      this.notifyChange(obj);
    }
  }

  private yieldValue() {
    if (this.form.valid) {
      this.notifyChange(this.outputValue);
    }
  }
}
